import React, { useEffect, useState } from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { Edit, Save } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { updateUser } from "../redux/actions/authActions";

const theme = createTheme();

const RootContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
});

const StyledAvatar = styled(Avatar)({
  width: 150,
  height: 150,
});

const InfoContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const StyledForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing(2),
}));

const StyledInput = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const ActionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(2),
}));

const ProfilePage = () => {
  const loginState = useSelector(state => state.auth);
  const isLoggedIn = (loginState && loginState.user);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [image, setImage] = useState("");
  const user = isLoggedIn ? loginState.user : null;
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoggedIn) {
      setFirstName(user.firstName);
      setLastName(user.lastName);
      setEmail(user.email);
      setRole(user.role);
    }
  }, [isLoggedIn, user]);

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value);
  };

  const handleLastNameChange = (event) => {
    setLastName(event.target.value);
  };

  const handleRoleChange = (event) => {
    setRole(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    setIsEditing(false);
    dispatch(updateUser(user._id, {...user, firstName, lastName, email, role}));
  };

  if (isLoggedIn) {
    return (
      <ThemeProvider theme={theme}>
        <RootContainer>
          <StyledAvatar alt="Profile Picture" src={image} />
          <InfoContainer>
            <Card>
              <CardHeader title="Profile Information" />
              <CardContent>
                <StyledForm>
                  <StyledInput
                    label="First Name"
                    value={firstName}
                    disabled={!isEditing}
                    fullWidth
                    onChange={handleFirstNameChange}
                  />
                  <StyledInput
                    label="Last Name"
                    value={lastName}
                    disabled={!isEditing}
                    fullWidth
                    onChange={handleLastNameChange}
                  />
                  <StyledInput
                    label="Email"
                    value={email}
                    disabled={!isEditing}
                    fullWidth
                    onChange={handleEmailChange}
                  />
                  <FormControl fullWidth>
                    <InputLabel id="role-label">Role</InputLabel>
                    <Select
                      labelId="role-label"
                      value={role}
                      disabled={!isEditing}
                      onChange={handleRoleChange}
                    >
                      <MenuItem value="Trader">Trader</MenuItem>
                      <MenuItem value="Researcher">Researcher</MenuItem>
                      <MenuItem value="Developer">Developer</MenuItem>
                    </Select>
                  </FormControl>
                  <ActionsContainer>
                    {!isEditing ? (
                      <IconButton onClick={handleEdit}>
                        <Edit />
                      </IconButton>
                    ) : (
                      <IconButton onClick={handleSave}>
                        <Save />
                      </IconButton>
                    )}
                  </ActionsContainer>
                </StyledForm>
              </CardContent>
            </Card>
          </InfoContainer>
        </RootContainer>
      </ThemeProvider>
    );
  } else {
    return (
      <div>
        <h1>Please log in to view this page.</h1>
      </div>
    );
  }
};

export default ProfilePage;
